<template>
  <div v-if="restaurantId !== -1" id="section-tabs" class="tab-content">
    <div class="flex">
      <div @click="showPopup" class="tr-button blue-button"><i class="fas fa-plus"></i> Add New Category</div>
      <div v-if="showSectionOrder" @click="saveSectionOrder" class="tr-button green-button ml-2"><i class="fas fa-check"></i> Save Section Order </div>
    </div>
    <div id="menu-category" class="menu-list">

      <div ref="table">
        <draggable
          tag="ul"
          v-model="sectionlist"
          class="list-group list-group-flush cursor-move w-full">
          <b-list-group-item
            :key="indextr"
            v-for="(tr, indextr) in sectionlist"
            class="w-full"
            tag="li">

            <div class="menu-list-item" :data="tr">
              <div class="menu-list-item-column">{{tr.name | title}}</div>
              <div class="menu-list-item-column">
                <div @click="showEditPopup(tr)" class="list-button"><i class="fas fa-edit"></i>Edit</div>
                <div class="list-button" @click.stop="confirmDelete(tr.id)"><i class="fas fa-trash"></i>Delete</div>

              </div>
            </div>
          </b-list-group-item>
        </draggable>
      </div>
    </div>
    <div id="popup" :class="openPopup ? 'active': ''">
      <div class="popup-cont">
        <h2 class="popup-heading">{{ popupCategory.id ? 'EDIT' : 'ADD NEW' }} CATEGORY</h2>
        <div class="popup-item">
          <input type="text" class="pop-input" v-model="popupName" placeholder="Category Name"
                 name="Category Name" v-validate="'required'">
          <span class="text-danger text-sm" v-show="errors.has('Category Name')">{{ errors.first('Category Name') }}</span>
        </div>
        <div class="popup-item">
          <textarea class="pop-textarea" placeholder="Description" v-model="popupDescription"
                    name="Category Description"></textarea>
          <span class="text-danger text-sm" v-show="errors.has('Category Description')">{{ errors.first('Category Description') }}</span>
        </div>
        <div class="popup-item">
          <div class="tr-button blue-button popup-button" @click="savePopupCategory">{{ popupCategory.id ? 'Edit' : 'Add' }} Category</div>
          <div @click="hidePopup" class="tr-button popup-button">Cancel</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UserSettingsGeneral from './UserSettingsGeneral.vue'
import UserSettingsChangePassword from './UserSettingsChangePassword.vue'
import UserSettingsInfo from './UserSettingsInfo.vue'
import AddSectionSidebar from './AddSectionSidebar'
import draggable from 'vuedraggable'
import { BListGroupItem} from 'bootstrap-vue'

export default {
  props: {
    restaurantId: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  watch: {
    restaurantId (newVal) { // watch it
      this.restaurantId = newVal
      this.getSectionList()
    },
    '$store.state.api.sectionlist' () {
    }
  },
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    UserSettingsInfo,
    AddSectionSidebar,
    BListGroupItem,
    draggable
  },
  data () {
    return {
      addNewDataSidebar: false,
      sidebarData: {},
      itemsPerPage: 20,
      selected: [],
      showSectionOrder: false,
      openPopup: false,
      popupName: '',
      popupDescription: '',
      popupCategory: {
        name: '',
        description: '',
        id: null
      }
    }
  },
  mounted () {
    this.getSectionList()
  },
  beforeMount () {
  },
  methods: {
    savePopupCategory () {
      this.$validator.validateAll().then(result => {
        this.$vs.loading()
        if (result) {
          const obj = {
            sectionId: this.popupCategory.id,
            name: this.popupName,
            description: this.popupDescription,
            restaurantId: this.restaurantId,
            sorting: this.sectionlist.length * 10
          }

          if (this.popupCategory.id) {
            obj.sorting = this.popupCategory.sorting
          }

          this.$store.dispatch('api/addSection', obj).then((response) => {
            this.$vs.notify({
              title: 'Success',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.hidePopup()
            this.getSectionList()
            this.$vs.loading.close()
          }).catch(err => {
            console.error(err)
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$vs.loading.close()
          })

        }
      })
    },
    resetPopupCategory () {
      this.popupCategory = {
        name: '',
        description: '',
        id: null
      }
      this.popupName = ''
      this.popupDescription = ''
    },
    showEditPopup (data) {
      this.popupCategory = data
      const {name, description} = data
      this.popupName = name
      this.popupDescription = description
      this.openPopup = true
    },
    showPopup () {
      this.openPopup = true
    },
    hidePopup () {
      this.openPopup = false
      this.resetPopupCategory()
    },
    saveSectionOrder () {
      const sections = []

      this.sectionlist.forEach((section) => {
        sections.push({sectionId: parseInt(section.id)})
      })

      const payload = {
        restaurantId: parseInt(this.restaurantId),
        sections
      }

      this.$vs.loading()
      this.$store.dispatch('api/arrangeSection', payload)
        .then(() => {
          this.showSectionOrder = false
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val


      if (val === false) {
        this.getSectionList()
        //this.$store.dispatch('api/setPropertyListForUser', {})
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.sidebarData.restaurantId = this.restaurantId
      this.toggleDataSidebar(true)
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text: `Status changed to: ${text}`
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        clickNotClose: true,
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    confirmDelete (id) {
      this.openConfirm(() => {
        this.deleteData(id)
      }, () => {

      })
    },
    deleteData (id) {
      const obj = {
        restaurantId: this.restaurantId,
        sectionId: id
      }
      this.$store.dispatch('api/removeSection', obj).then(() => {
        this.$vs.notify({
          title: 'Delete',
          text: 'Item deleted succesfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }).catch(err => { console.error(err) })
    },
    getSectionList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getSectionList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  computed: {
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.sectionlist.length
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    sectionlist: {
      get () {
        return this.$store.state.api.sectionlist
      },
      set (value) {
        this.$store.commit('api/SET_SECTION_LIST', value)
        this.showSectionOrder = true
      }
    }
  }
}
</script>
